import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

// Read-only transaction ledger for one employee. `data.transactions$` is the
// realtime observable from MembershipV2Service.getMembershipTransactions$.
@Component({
  selector: 'v2-ledger-dialog',
  template: `
  <h2 mat-dialog-title>Ledger — {{ data.name }}
    <span class="v2-ledger-bal">balance {{ data.credit }}</span>
  </h2>
  <mat-dialog-content>
    <table class="v2-ledger-table" *ngIf="(data.transactions$ | async) as rows">
      <thead><tr><th>Date</th><th>Type</th><th>Amount</th><th>Balance</th><th>Message</th></tr></thead>
      <tbody>
        <tr *ngFor="let t of rows">
          <td>{{ fmt(t.createdOn) }}</td>
          <td><span class="v2-tx" [class.credit]="t.type === 'credit'" [class.debit]="t.type === 'debit'">{{ t.type }}</span></td>
          <td>{{ t.ammount != null ? t.ammount : t.amount }}</td>
          <td>{{ t.balance }}</td>
          <td>{{ t.message }}</td>
        </tr>
        <tr *ngIf="rows.length === 0"><td colspan="5" class="v2-ledger-empty">No transactions yet.</td></tr>
      </tbody>
    </table>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="ref.close()">Close</button>
  </mat-dialog-actions>
  `,
  styles: [`
    .v2-ledger-bal { font-size: 13px; color: #666; font-weight: 400; margin-left: 8px; }
    .v2-ledger-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 480px; }
    .v2-ledger-table th, .v2-ledger-table td { text-align: left; padding: 6px 10px; border-bottom: 1px solid #eee; }
    .v2-ledger-table th { color: #888; font-weight: 600; }
    .v2-ledger-empty { color: #999; text-align: center; font-style: italic; }
    .v2-tx { border-radius: 10px; padding: 1px 8px; font-size: 11px; text-transform: capitalize; }
    .v2-tx.credit { background: #e6f4ea; color: #1e7e34; }
    .v2-tx.debit { background: #fdecea; color: #b3261e; }
  `]
})
export class LedgerDialogComponent {
  constructor(
    public ref: MatDialogRef<LedgerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  fmt(unix: number) { return unix ? moment.unix(unix).format('YYYY-MM-DD HH:mm') : ''; }
}
